module.exports = __webpack_public_path__ + "Silver-35690b06590714c72a5115802de7b167.png";